__turbopack_context__.v({
  "menu": "AgreementsMenu-module-scss-module__F79zcq__menu",
  "menu-selected": "AgreementsMenu-module-scss-module__F79zcq__menu-selected",
});
